import { render, staticRenderFns } from "./TemporaryCashAllocationPrint.vue?vue&type=template&id=628c838c&"
import script from "./TemporaryCashAllocationPrint.vue?vue&type=script&lang=js&"
export * from "./TemporaryCashAllocationPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports